var newTheme = {"currency-dropdown-popup-new":"CryptoSelect_currency-dropdown-popup-new_1qhfu_1"};

export { newTheme as default };
//# sourceMappingURL=new-theme.module.scss.js.map
